import { useTranslation } from 'react-i18next';

import { ButtonProps } from '@components/Button';
import Modal, { IconBlock, MessageBlock, ActionBlock, Title } from '@components/Modal';

export interface ErrorMessage {
  errorCode?: string;
  message: string[];
}

interface ErrorModalProps {
  icon?: string;
  title?: string;
  titleSize?: 'small' | 'medium' | 'large' | 'larger';
  errorCode?: string;
  warningText?: boolean;
  messages: string | string[];
  buttonText?: string;
  retryOption?: boolean;
  onRetry?: () => Promise<void> | void;
  onClick: () => void;
  additionalActions?: ButtonProps[];
  appearance?: 'primary' | 'secondary' | 'tertiary' | 'counter' | 'text';
}

const commonLanguageNamespace = 'common';

export const ErrorModal = ({
  icon,
  title,
  titleSize = 'medium',
  messages,
  errorCode,
  buttonText,
  appearance,
  onClick,
  retryOption = false,
  onRetry,
  additionalActions,
}: ErrorModalProps) => {
  const { t } = useTranslation(commonLanguageNamespace);

  const actions: ButtonProps[] = [
    {
      appearance: appearance ?? 'primary',
      text: buttonText ?? t('ok'),
      onClick,
    },
  ];

  if (additionalActions) {
    actions.push(...additionalActions);
  }

  if (retryOption) {
    actions.push({
      appearance: 'primary',
      text: t('retry'),
      onClick: () => (onRetry ? onRetry() : window.location.reload()),
    });
  }

  return (
    <Modal minWidth="45rem" testId="error-modal">
      <IconBlock icon={icon ?? 'warning'} />
      {title && <Title title={title} fontSize={titleSize} />}
      {errorCode && <Title title={`${t('errors.errorCode')}: ${errorCode}`} />}
      <MessageBlock messages={messages} />
      <ActionBlock actions={actions} />
    </Modal>
  );
};
